import WorksZHMeta from './works_zh.json';
import createPocketBaseWorksLoader from './pocketbase';

// Collection names are code/data contracts, not deployment environment settings.
const loadWorksZH = createPocketBaseWorksLoader({
  collection: 'works',
  lang: 'zh',
});

export { WorksZHMeta };

export default loadWorksZH;
